export default "__VITE_ASSET__BINDcgTE__"